export default "__VITE_PUBLIC_ASSET__60de7d9a__"